// ABOUTME: Exposes the themed page background colour configured in settings (theme.bgColor).
// ABOUTME: Sticky bars need it to stay opaque while blending with the page behind them.

import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext } from 'react';

export const DEFAULT_PAGE_BG_COLOR = '#ffffff';

export const usePageBgColor = (): string => {
    const { theme } = useContext(SettingsContext);

    return theme?.bgColor ?? DEFAULT_PAGE_BG_COLOR;
};
